module.exports = __webpack_public_path__ + "static/draft1sales-4fbe24495e356d795767379cdff8c170.png";